import { PageUrl } from '../../../../pages/utils/page-url';
import type { LinksToRetrieve } from '../types';

export const links: LinksToRetrieve[] = [
    {
        id: 1,
        url: { action: PageUrl.PAGE_SHOW, args: ['cid', 'about-us'] },
    },
    {
        id: 2,
        url: { action: PageUrl.PAGE_SHOW, args: ['cid', 'careers'] },
    },
    {
        id: 3,
        url: { action: PageUrl.PAGE_SHOW, args: ['cid', 'privacy-policy'] },
    },
    {
        id: 4,
        url: { action: PageUrl.PAGE_SHOW, args: ['cid', 'mediarelations'] },
    },
    {
        id: 5,
        url: { action: PageUrl.PAGE_SHOW, args: ['cid', 'affiliateprograms'] },
    },
    {
        id: 6,
        url: { action: PageUrl.SEARCH_SHOW, args: ['cgid', 'coupons-promotions-at-slt'] },
    },
    {
        id: 7,
        url: { action: PageUrl.SEARCH_SHOW, args: ['cgid', 'Make-More'] },
    },
];
